import React, { ChangeEventHandler, forwardRef } from 'react';
import { InputProps as AntInputProps, InputRef } from 'antd';
import { TestProps } from 'core/utils/testTypes';
import { StyledInput } from './styles';

export interface InputProps extends AntInputProps, TestProps {
    addonAfter?: React.ReactNode;
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
    allowClear?: boolean;
    bordered?: boolean;
    placeholder?: string;
    id?: string;
    value?: string;
    disabled?: boolean;
    style?: React.CSSProperties;
    maxLength?: number;
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
    onChange?: ChangeEventHandler<HTMLInputElement>;
}

const Input = forwardRef<InputRef, InputProps>(({ className, type, ...rest }, ref) =>
    type === 'password' ? (
        <StyledInput.Password {...rest} ref={ref} className={className} />
    ) : (
        <StyledInput {...rest} ref={ref} className={className} />
    )
);

export default Input;
